module.exports = __webpack_public_path__ + "static/media/animation.a4dac182.svg";